const numberInputs = document.querySelectorAll('.number-input-ls');

numberInputs.forEach((container) => {
  const decreaseBtn = container.querySelector('button:first-child');
  const increaseBtn = container.querySelector('button:last-child');
  const input = container.querySelector('input');

  // Set initial value and button state
  if (!input.value || parseInt(input.value) < 1) {
    input.value = 1;
  }
  updateDecreaseButton();

  decreaseBtn.addEventListener('click', () => {
    let currentValue = parseInt(input.value) || 1;
    input.value = Math.max(1, currentValue - 1);
    updateDecreaseButton();
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  increaseBtn.addEventListener('click', () => {
    let currentValue = parseInt(input.value) || 1;
    input.value = currentValue + 1;
    updateDecreaseButton();
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  input.addEventListener('change', () => {
    let value = parseInt(input.value) || 1;
    input.value = Math.max(1, value);
    updateDecreaseButton();
  });

  // Function to update decrease button state
  function updateDecreaseButton() {
    const currentValue = parseInt(input.value);
    if (currentValue <= 1) {
      decreaseBtn.disabled = true;
    } else {
      decreaseBtn.disabled = false;
    }
  }
});
